module.exports = __webpack_public_path__ + "img/img_origfac_blockend.0efe8aae.png";